import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface PatientInfoSectionProps {
  account: any;
}

export const PatientInfoSection: React.FC<PatientInfoSectionProps> = ({ account }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
      Patient Information
    </Typography>
    <Stack spacing={1}>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>ID:</strong> {account.id || 'N/A'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            <strong>Name:</strong> {account.patient?.firstName} {account.patient?.lastName}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Account #:</strong> {account.accountNumber || 'N/A'}
          </Typography>
        </Box>
      </Box>
    </Stack>
  </Box>
);

export default PatientInfoSection;
